import { gql } from '@apollo/client';

export const GET_ADMIN_ANALYTICS = gql`
  query AdminAnalytics {
    response: admin_analytics {
      hasError
      message
      data
    }
  }
`;

export const LIST_TOP_REFERRERS = gql`
  query ListTopReferrers(
    $startDate: String!
    $endDate: String!
    $limit: Int
    $offset: Int
  ) {
    list_top_referrers(
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      offset: $offset
    ) {
      hasError
      message
      data {
        referrers {
          _id
          first_name
          last_name
          email
          verified
          status
          allow_referral
          referral_code
          created_at
          updated_at
          effective_referrals_count
          total_referrals_count
          referral_stats {
            account_created
            agent_created
            channel_connected
            subscription_created
            rejected
          }
        }
        pagination {
          limit
          offset
          total
          hasMore
        }
        dateRange {
          startDate
          endDate
        }
      }
    }
  }
`;

export const GET_REFERRALS_BY_REFERRER = gql`
  query GetReferralsByReferrer(
    $referrerOwnerId: String!
    $limit: Int
    $offset: Int
  ) {
    get_referrals_by_referrer(
      referrerOwnerId: $referrerOwnerId
      limit: $limit
      offset: $offset
    ) {
      hasError
      message
      data {
        referrals {
          _id
          referrer_owner_id
          referee_owner_id
          agent_id
          status
          created_at
          updated_at
          stripe_customer_id
          stripe_subscription_id
          rejected {
            reason
            timestamp
          }
          referee_details {
            first_name
            last_name
            email
            status
            verified
          }
        }
        pagination {
          limit
          offset
          total
          hasMore
        }
        referrerInfo {
          referrer_owner_id
        }
      }
    }
  }
`;

export const SEARCH_OWNERS = gql`
  query SearchOwners($email: String!, $limit: Int, $offset: Int) {
    search_owners(email: $email, limit: $limit, offset: $offset) {
      hasError
      message
      data {
        owners {
          _id
          first_name
          last_name
          email
          verified
          status
          allow_referral
          referral_code
          created_at
          updated_at
        }
        total
        hasMore
        limit
        offset
      }
    }
  }
`;

export const LIST_OWNERS = gql`
  query ListOwners($limit: Int, $offset: Int) {
    list_owners(limit: $limit, offset: $offset) {
      hasError
      message
      data {
        owners {
          _id
          first_name
          last_name
          email
          verified
          status
          allow_referral
          referral_code
          created_at
          updated_at
        }
        pagination {
          limit
          offset
          total
          hasMore
        }
      }
    }
  }
`;

export const ACTIVATE_OWNER_REFERRAL = gql`
  mutation ActivateOwnerReferral($ownerId: String!) {
    activate_owner_referral(ownerId: $ownerId) {
      hasError
      message
      data {
        owner_id
        allow_referral
        referral_code
        activated_at
      }
    }
  }
`;
